import { useNavigate } from 'react-router-dom';
import { logout } from '@/portal/api/Sessions';

export function useLogout(redirectPath = '/portal/login') {
  const navigate = useNavigate();

  return async () => {
    await logout();
    navigate(redirectPath);
  };
}
